module.exports = __webpack_public_path__ + "media/images/lb/889-9a541f9ebdb4613516e4a107bed1d5db.svg";